import React from 'react';
import { cn } from '../../lib/utils';

export interface TableHeaderDef {
    label: string;
    align?: 'left' | 'center' | 'right';
    className?: string;
}

interface DataTableShellProps {
    headers: TableHeaderDef[];
    children: React.ReactNode;
    className?: string;
}

const DataTableShell: React.FC<DataTableShellProps> = ({ headers, children, className }) => {
    return (
        <div className={cn('overflow-x-auto', className)}>
            <table className="w-full">
                <thead className="bg-gray-100 border-b-2 border-gray-300">
                    <tr>
                        {headers.map((h, idx) => (
                            <th key={idx} className={cn('px-6 py-4 text-xs font-semibold text-gray-700 uppercase tracking-wider', h.align === 'center' ? 'text-center' : h.align === 'right' ? 'text-right' : 'text-left', h.className)}>
                                {h.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">{children}</tbody>
            </table>
        </div>
    );
};

export default DataTableShell;
